import i18n, { type TFunction } from 'i18next'
import { deepMerge } from '@/utils/object'
import { Language } from './constants'

declare module 'i18next' {
  interface i18n {
    /** @deprecated Please don't use it directly. Please use changeLanguage from '@/i18n' */
    changeLanguage: (lang: string) => Promise<TFunction>
  }
}

// Lazy loaders
const LANGAUAGES_LOADERS_MAPPING: Record<
  Language,
  () => Promise<Record<string, unknown>[]>
> = {
  [Language.TH]: () =>
    Promise.all([import('@/ui-components/i18n/th.json'), import('./th.json')]),
  [Language.EN]: () =>
    Promise.all([import('@/ui-components/i18n/en.json'), import('./en.json')]),
  [Language.MY]: () =>
    Promise.all([import('@/ui-components/i18n/my.json'), import('./my.json')]),
  [Language.KM]: () =>
    Promise.all([import('@/ui-components/i18n/km.json'), import('./km.json')]),
}

// Lazy load language resources
const loadLanguageResources = async (language: Language) => {
  if (!LANGAUAGES_LOADERS_MAPPING[language]) {
    throw new Error(`Unsupported language: ${language}`)
  }

  const langs = await LANGAUAGES_LOADERS_MAPPING[language]()
  return deepMerge(langs[0], langs[1])
}

/**
 * Change language and load resources if not already loaded
 * @param lang - Language to change to
 */
export const changeLanguage = async (lang: Language) => {
  // Load language resources if not already loaded
  if (!i18n.hasResourceBundle(lang, 'translation')) {
    const translations = await loadLanguageResources(lang)
    i18n.addResourceBundle(lang, 'translation', translations, true, true)
  }

  void i18n.changeLanguage(lang)
}
